var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "dialog", staticClass: "dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            "append-to-body": _vm.appendToBody,
            width: _vm.width,
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.onOpen,
            opened: _vm.onOpened,
            close: _vm.onClose,
            closed: _vm.onClosed,
          },
        },
        [
          _vm.splitLine ? _c("div", { staticClass: "split-line" }) : _vm._e(),
          _vm.scrollbar
            ? _c(
                "el-scrollbar",
                { staticClass: "dialog" },
                [_vm._t("default")],
                2
              )
            : _vm._t("default"),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [_vm._t("footer")],
            2
          ),
        ],
        2
      ),
      _c("transition", { attrs: { name: "dialog-modal-fade" } }, [
        _vm.modal && _vm.dialogVisible
          ? _c("div", {
              staticClass: "v-dialog-modal",
              style: [{ zIndex: _vm.zIndex }],
            })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }